import Vue from 'vue'
import {Http} from 'vue-resource'
//Vue.use(VueResource)
import api from './api.js'
import CryptoJS from './cipher-core-min.js'
let onlinehost='https://wukongvote.com?s='
console.info('process.env',process.env)
let javaHost='https://pcapi.wukongvote.com/'
if("development"==process.env.NODE_ENV || location.href.indexOf('pc.wukongvote.com')>-1){
	javaHost='https://cloudtest.wukongvote.com/'
}
//ws://119.29.166.29:8081/webproxy/vking  {"identity":"vking","params":{"a":"b"}}
//const javaHost='http://xsb248079438.u1.luyouxia.net:51477/'
window.wxlite={
  getStorageSync:function(key){
  	let val=localStorage.getItem(key)
    return /^[\{\[].*[\}\]]$/.test(val)?JSON.parse(val):val;
	},
  setStorageSync:function(key,val){
    localStorage.setItem(key,val)
	},
  request(parmas){
    return Http(parmas)
	}
}
async function request(url,data={},mode){
  //console.log('request',...arguments)
  let host=onlinehost;
  let apikey=url
  if(api[apikey] && api[apikey].alias){
    url=api[apikey].alias
  }
	if(api[apikey] && api[apikey].useJavaHost){
  	host=javaHost
		if(api[apikey].params){
      Object.keys(api[apikey].params).forEach((oldkey)=>{
        let newkey=api[apikey].params[oldkey]
				if(typeof data[oldkey]!='undefined'){
          data[newkey]=data[oldkey]
          delete data[oldkey]
				}
			})
		}
    delete data['openid']
    //url参数替换
    if(url.indexOf('{')>-1){
      url=url.replace(/\{([^\}]+)\}/g,function($0,$1){
        let val=data[$1]||''
        delete data[$1]
        return val
      })
    }
		return await demand(url,mode||api[apikey].method,data);
	}
	throw new Error(url+',use old api!!!')
	//生成签名
	let obj=randomChar();
	let arr=[obj.timestamp,obj.nonce,'3hGVRy5^4imm4ZpZNy3YBpuPc!#3Ya#*'];
	let str='';
	arr.sort();
	for(let i=0;i<3;i++){
		str+=arr[i]
	}
	console.log(arr,str)
	console.log('排序sha256:',CryptoJS.CryptoJS.SHA256(str).toString());
  let parm={
    timestamp:obj.timestamp,
    nonce:obj.nonce,
    sign:CryptoJS.CryptoJS.SHA256(str).toString()
  }
  url+=((host+url).indexOf('?')>-1?'&':'?')
    +'timestamp='+parm.timestamp
    +'&nonce='+parm.nonce
    +'&signature='+parm.sign
	console.log('request.url',host+url)
	return new Promise(function(resolve, reject) {
    wxlite.request({
			url:host+url,
			method: mode,
			data:data,
			header: {
				'content-type': 'application/x-www-form-urlencoded',   // 默认值
			},
			success:function(res){
				console.log('xxxxxxsuccess:',res)
				resolve(res.data)
			},
			fail:function(res){
				console.log('xxxxxxfail:',res)
        wxlite.hideToast();
        wxlite.showToast({
					title:'网络请求超时',
					icon:'none',
					mask:true,
					duration:2000,
				})
				reject(res)
			}
		})
	});
}
function demand(url,method='POST',data={}){
	let host=javaHost;
	// if(url.indexOf('getActivityQrcode')>0){//二维码使用线上地址
   //  host='https://fotooapi.wukongvote.com/'
	// }
	if(/http(s)?:\/\//.test(url)){
		host=''
	}
	//生成签名
	//console.log('demand',host+url,method)
	let obj=randomChar();
	let arr=[obj.timestamp,obj.nonce,'3hGVRy5^4imm4ZpZNy3YBpuPc!#3Ya#*'];
	let str='';
	arr.sort();
	for(let i=0;i<3;i++){
		str+=arr[i]
	}
	//console.log(arr,str)
	//console.log('排序sha256:',CryptoJS.CryptoJS.SHA256(str).toString());
	let parm={
		timestamp:obj.timestamp,
		nonce:obj.nonce,
		sign:CryptoJS.CryptoJS.SHA256(str).toString()
	}
	url=url.replace(/^\//,'')
  if(method=='URL'){
		let query=[]
		Object.keys(data).forEach(k=>{
      query.push(k+'='+data[k])
		})
    return host+url+(query.length>0?('?'+query.join('&')):'')
  }
  let now=new Date()/1
	return new Promise(function(resolve, reject) {
		let token=wxlite.getStorageSync('token') ? wxlite.getStorageSync('token') : ''
    // Vue.http.options.emulateHTTP = true;
    // Vue.http.options.headers = {
    //   'content-type': 'application/json',   // 默认值
    //   ...parm,
    //   'authorization':token
    // }
    let headers={
      'content-type': 'application/json',   // 默认值
      //...parm,
      'authorization':token
    }
		if(method=='GET'){
		  headers['content-type']='application/x-www-form-urlencoded'
      // url+='?'
			// Object.keys(data).forEach(key=>{
			// 	url+=key+'='+data[key]+'&'
			// })
			// url=url.substr(0,url.length-1)
		}
		let responseType=''
		if(url.indexOf('Excel')>-1){
      responseType='arraybuffer'
		}
    wxlite.request({
			url:host+url,
			method: method,
			//data:data,
      params:method=='GET'?data:null,
			body:data,
      headers: headers,
      responseType: responseType,
			success:async function(res){

				
			},
			fail:function(res){

			}
		}).then(async res=>{
      console.info(method+'('+(new Date()/1-now)+'ms):'+host+url+'\t'+token+'\n\t',data,'\n\t',res.data);
      if(res.data.code==401){
        localStorage.removeItem('userinfo');
        localStorage.removeItem('token');
        //window.location.href='/'
        window.location.replace('/')
        //resolve(await login(url,method,data));
      }else{
        let resData=res.data;
        //console.log('resData',typeof resData)
          if(typeof resData == 'object' && resData.code){
            resData=JSON.stringify(resData);
            resData=resData.replace(/http:\/\//g,'https://');
            resData=JSON.parse(resData);
          }
          resolve(resData);
      }
		}).catch(res=>{
      console.info(method+':'+host+url+'\n\t',data,'\n\t',res);
      try{
        wxlite.hideToast();
        wxlite.showToast({
          title:'网络请求超时',
          icon:'none',
          mask:true,
          duration:2000,
        })
			}catch(e){}
      reject(res)
		})
	});
}
async function login(url,method='POST',data={}){
	let logindata={
		sourceType:0,
		wechatUserInfo:{
			openid:wxlite.getStorageSync('openid'),
			unionId:wxlite.getStorageSync('unionid')
		}
	}
	let json=await demand('fotooLogin/login','POST',logindata);
  if(json.code==200){
    wxlite.setStorageSync('token',json.data.token);
    wxlite.setStorageSync('userId',json.data.userId);
    return demand(url,method,data);
  }
}
function randomChar()  {
	var  x="0123456789qwertyuioplkjhgfdsazxcvbnm";
	var  tmp="";
	var timestamp = Date.parse(new Date())/1000;
	for(var  i=0;i<12;i++)  {
		tmp  +=  x.charAt(Math.ceil(Math.random()*100000000)%x.length);
	}
	//console.log('nonce:',tmp,timestamp)
	return {nonce:tmp,timestamp:timestamp};
}
function setapi(){
   let tempapi={};
   let keys=[];
   for(let key in api){
	   keys=key.split('.');
	   tempapi[keys[0]]=tempapi[keys[0]]?tempapi[keys[0]]:{};
	   tempapi[keys[0]][keys[1]]=tempapi[keys[0]][keys[1]] ? tempapi[keys[0]][keys[1]] : {};
	   tempapi[keys[0]][keys[1]][keys[2]]=function(data,mode){
       //console.log('request.api',key,data,mode)
			 return request(key,data,mode)
	   }
   }
   return tempapi[keys[0]];
}
function getpages(){
	var pages=getCurrentPages();
	return pages;
}
function setTitle(title){
  wxlite.setNavigationBarTitle({
		title:title
	})
}
function cache(key,value=''){
	if(value!=''){
    wxlite.setStorageSync(key,value)
	}else{
		return wxlite.getStorageSync(key)
	}
}
function removecache(key){
  wxlite.removeStorageSync(key)
}
function unixtoTime(ns,format) {
    var result;
    var time = new Date(ns*1000);
    //result=format || 'YYYY年MM月DD日 HH时II分SS秒 WW';
    result=format || 'YYYY年MM月DD日';
    //console.log(time);
    result=result.toUpperCase();
    result=result.replace('YYYY',time.getFullYear());
    var m=time.getMonth()+1;
    result=result.replace('MM',m>9?m:"0"+m);
    var d=time.getDate();
    result=result.replace('DD',d>9?d:'0'+d);
    var hh=time.getHours();
    result=result.replace('HH',hh>9?hh:'0'+hh);
    var ii=time.getMinutes();
    result=result.replace('II',ii>9?ii:'0'+ii);
    var ss=time.getSeconds();
    result=result.replace('SS',ss>9?ss:'0'+ss);
    var week;
    switch (time.getDay()) {
        case 0:week="日";break
        case 1:week="一";break
        case 2:week="二";break
        case 3:week="三";break
        case 4:week="四";break
        case 5:week="五";break
        case 6:week="六";break
    }
    result=result.replace('WW',week);
    if(format.indexOf('DAY')>0){
        // 获取当天 0 点的时间戳
        var timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;

        var day1 = timeStamp+86400//今天结束
        var day2 = day1+86400//明天结束

        //console.log('ns<day.getTime()',timeStamp,ns,day1,day2)

        if(ns>=timeStamp && ns<day1){
            result=result.replace('DAY','今天');
        }else{
            if(ns>=day1 && ns<day2){
                result=result.replace('DAY','明天');
            }else{
                result=result.replace('DAY','');
            }
        }
    }
    if(format.indexOf('`')>0){
        result=result.replace(/`(.*)\/(.*)`/ig,function($0,$1,$2){
            return $1||$2;
        });
    }
    return result;
}
function upload(count=9,sizetype=['original', 'compressed'],sourceType=['album', 'camera'],url,name,formdata={}){
  wxlite.chooseImage({
	  count:count,
	  sizeType:sizetype,
	  success(res) {
			const tempFilePaths = res.tempFilePaths
			return new Promise(function(resolve, reject){
        wxlite.uploadFile({
				  url: url, // 仅为示例，非真实的接口地址
				  filePath: tempFilePaths[0],
				  name: name,
				  formData:formdata,
				  success(res) {
					const data = res.data
					resolve(res.data)
					// do something
				  },
				  fail(res){
					reject(res)  
				  }
				})
			})
		
	  }
    })
}
//去除字符串中的所有空格
function removespace(str){
    return str.replace(/\s|\xA0/g,"");
}
//删除左右两端的空格
function strtrim(str){ 
    return str.replace(/(^\s*)|(\s*$)/g, "");
	
}
function latlngtoaddress(lat,lng){
	let latitude=0,longitude=0;
	for(let i=0;i<3;i++){
		if(i==0){
			latitude=latitude+Number(lat[i]);
			longitude=longitude+Number(lng[i]);
		}else{
			if(i==1){
				latitude=latitude+Number(lat[i])/60;
				longitude=longitude+Number(lng[i])/60;
			}else{
				latitude=latitude+Number(lat[i])/3600;
				longitude=longitude+Number(lng[i])/3600;
			}
		}
	}
	return {
		latitude:latitude,
        longitude:longitude
	}
}
function changedate(timestamp){
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y= date.getFullYear();
        var M =date.getMonth()+1;
        var D =date.getDate();
        var h = date.getHours();
        var m = date.getMinutes();
        var s = date.getSeconds();
        var w=date.getDay();
        return {year:Y,month:M,day:D,hour:h,minute:m,second:s,week:w};

}
//时间转化时间戳
function gettimestamp(stringTime){
    var date = new Date(stringTime.replace(/-/g, '/'));
    var timestamp2=Date.parse(date)/1000;
    return timestamp2
}
//时间戳转化日期
function getdate(timestamp,connect='-',formdate='YY-MM-DD'){
	let dateobj=changedate(timestamp);
	let date=dateobj.year+connect+(dateobj.month<10 ? '0'+dateobj.month : dateobj.month)+connect+(dateobj.day<10 ? '0'+dateobj.day : dateobj.day);
	if(formdate.indexOf('hh:mm')!=-1){
		date+=' '+(dateobj.hour<10 ? '0'+dateobj.hour : dateobj.hour)+':'+(dateobj.minute<10 ? '0'+dateobj.minute : dateobj.minute)
	}
	if(formdate.indexOf('ss')!=-1){
		date+=':'+(dateobj.second<10 ? '0'+dateobj.second : dateobj.second)
	}
	return date;
}
//计算当前过去天数
function currentdays(){
	let date=new Date();
	let currentmonth=date.getMonth()+1;
	let currentday=date.getDate();
	let days_30=[4,6,9,11];
	let days=0;
	for(let i=1;i<currentmonth;i++){
		if(i==2){
			if(date.getFullYear()%4==0){
				days+=29;
			}else{
				days+=28;
			}
		}else{
			if(days_30.indexOf(i)){
				days+=30
			}else{
				days+=31
			}
		}
		
	}
	console.log(days+currentday)
	let totalday=days+currentday
	return totalday
}
//计算日出时间long经度 lat纬度 days到今天过去多少天
function runrise(long,lat){
	console.log(long,lat)
	let days=currentdays();
	let pi=Math.PI;
	let timeborder=long/15;
    let rise=(180+timeborder*15-long-Math.acos(Math.tan(10547*pi/81000*Math.cos(2*pi*(days+9)/365))*Math.tan(lat*pi/180))*180/pi)/15
	console.log(rise)
	return rise;
}

//违规内容检测	
function discover(content){
	console.log(encode(content))
  wxlite.cloud.callFunction({
		name:'discover',
		data:{
			content:content
		}
	}).then(res=>{
		console.log('成功',res)
		return 'success'
	}).catch(err => {
		console.log('失败',err)
		return 'fail'
	})
}
export default {
	...setapi(),
	pages:getpages,
	cache:cache,
	setTitle:setTitle,
	upload:upload,
	removespace:removespace,
	strtrim:strtrim,
	latlngtoaddress:latlngtoaddress,
	changedate:changedate,
	gettimestamp:gettimestamp,
	removecache:removecache,
	runrise:runrise,
	discover:discover,
	getdate:getdate,
	unixtoTime:unixtoTime,
	randomChar:randomChar,
	CryptoJS:CryptoJS,
	demand:demand,
  /**
   * @param str
   * @param type 投稿、活动
   */
  metaTypeHD:'activitySubmissionType',
  metaTypeTG:'activityMaterialType',
	metaKey(key,type){
  	let kv
  	switch (type){
			case this.metaTypeHD:
        kv={
          Picture:"1",
          Video:"2",
          PictureAndVideo:"3",
          Word:"4",
          Document:"5",
				}
				break;
      case this.metaTypeTG:
				kv={
          PictureMaterialType:"1",
          VideoMaterialType:"2",
          AudioMaterialType:"3",
          WordMaterialType:"4",
          DocumentMaterialType:"5",
				}
        break;
			default:
				throw new Error('metaType is undefined!')
				return;
		}
		if(Number.isNaN(key/1)){//key 转数字
			return kv[key]||''
		}else{//数字转key
			let keyStr=''
			Object.keys(kv).some(k=>{
				if(kv[k]==key){
          keyStr=k
					return true
				}
			})
			return keyStr
		}
	},
  setStorageUserinfo(params,hasWork=false){
    let userinfo=wxlite.getStorageSync('userinfo')
		let setKeys={
      'userName':['nickName','userName'],
      'mobile':['phone','mobile'],
			'qq':['qq'],
      'email':['email'],
			'wechat':['wechat'],
			'avatar':['avatarUrl','avatar']
		}
		Object.keys(params).forEach(key=>{
      setKeys[key].forEach(sk=>{
        userinfo[sk]=params[key]
			})
		})
    wxlite.setStorageSync('userinfo',userinfo)
		if(hasWork){
      let workinfo=wxlite.getStorageSync('workinfo')
      Object.keys(params).forEach(key=>{
        let sk=setKeys[key][0]
        workinfo[sk]=params[key]
      })
      wxlite.setStorageSync('workinfo',workinfo)
		}
		return  userinfo
	},
  mdx(str){
    if(typeof str!='string'){
      str=JSON.stringify(str);
    }
    let num=0;
    let len=str.length;
    for(let i=0;i<len;i++){
      num+=(i+1)*str.charCodeAt(i);
    }
    return parseInt(Math.random()*new Date())+num;
  },
  /**
	 * old vue $http 自动转化
   */
	async oldHttp(options){
    let uri=options.url.match(/\?s=([^&]+)/)
    console.log('this.$http',uri[1])
		//return await Http(options)
		return request(uri[1],options.params)
	},
	async download(url,filename,hasFileBlod=false){
    let headers={'content-type':'application/x-www-form-urlencoded'};
    
		let res=await wxlite.request({
      url:this.url2https(url),
      method: 'GET',
      //data:data,
      //params:data,
      //body:data,
      headers: headers,
      responseType: 'arraybuffer',
    })
    console.log(res)
    if(hasFileBlod){
      return res.body
    }
    let type=res.headers.map['content-type']
    let data=res.body
    let blob = new Blob([data], {type: type})
    
    //let blob = new Blob([data]);
    let aurl = window.URL.createObjectURL(blob)
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = aurl
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
		//console.log('download',res.body.byteLength,res.headers.map['content-type'])
		return {size:res.body.byteLength,name:filename,type: type}
	},
  async downloadZip(url,filename,zip){
    try{
      let res=await wxlite.request({
        url:this.url2https(url),
        method: 'GET',
        //data:data,
        //params:data,
        //body:data,
        headers: {'content-type':'application/x-www-form-urlencoded'},
        responseType: 'arraybuffer',
      })
      zip.file(filename,res.body)
		}catch (e){
      return await this.downloadZip(url,filename,zip)
		}
  },
	url2https(url){
  	//if(this.hasTest()) return url
    return url.replace(/http:\/\/(kk)?/,function($1,$2){
      console.log('match',$1,$2)
      if($2){ return 'https://qn'}
      return 'https://'
    })
	},
	hasTest(){
		//return false
    return "development"==process.env.NODE_ENV || location.href.indexOf('www.wukongvote.com')<0
	},
  hasTestStyle(){
    return location.href.indexOf('pc.wukongvote.com')>0
  },
	MG(num,fixed=2){
  	if(!num) return '0M'
  	let M=1024*1024,dot='M'
		let val=(num/M).toFixed(fixed)
		if(val>1024){
  		dot='G'
  		val=(val/1024).toFixed(fixed)
		}
		return val+dot
	},
	ip2addr:{},
  identityTypes(identityType=-1){
		if(identityType==-1) return 'Error'
		return ['发起人','管理员','协作者'][identityType]||'未知'
  },
  http_build_query(obj, url = '',hasH5=false) {
    let ps = [];
    for (let i in obj) {
      if (typeof obj[i] == 'undefined' || obj[i] == null || obj[i] === false) continue;
      ps.push(i + (hasH5?'/':'=') + obj[i].toString())
    }
    ps = ps.join(hasH5?'/':'&');
    if (!url) {
      return ps;
    }
    if(hasH5){
      url += (url.indexOf('#/') > -1 ? '' : '#/') + ps;
    }else{
      url += (url.indexOf('?') > -1 ? '&' : '?') + ps;
    }
    return url;
  },
  setPlayerUrl(image){
    let playerUrl=image.url,__playerUrl=image.url;
    let __transcodeType=1;//通用场景
    let hasTransed=false;
    if(image.transcodeMaterialList && image.transcodeMaterialList.length>0){
      image.transcodeMaterialList.forEach(tr=>{
        if(tr.transcodeType==__transcodeType){
          __playerUrl=tr.url;
          hasTransed=true
        }
      })
    }
    image.playerUrl=__playerUrl;
    image.hasTransed=hasTransed;
    return image.playerUrl
  },
  getH5(params={},path=''){
    let nt=new Date()/1000;
    let url='https://wukongvote.com/?'+(this.hasTest()?('--DEBUG--CLOUD--'+nt):'')+this.unixtoTime(nt,'MMDD')+'#/'
      +(path?(path+'/'):'');
    return this.http_build_query(params,url,true)
  },
  buyVipUrl(userId){
  	let buyVipUrl=this.getH5({
      version:encodeURIComponent(JSON.stringify({
        from:'pc',
        token:wxlite.getStorageSync('token'),
        uid:userId||wxlite.getStorageSync('userId')})),
      "_":'',
    },'')
		console.log(buyVipUrl)
    return buyVipUrl
	},
};



// WEBPACK FOOTER //
// ./src/util/comfun.js